import BaseCommand from "@/models/api/commands/BaseCommand";

export interface CopyAttributeToOtherOrderItemsCommandParams {
  AttributePrototypeId: number;
  Value: string;
  IsPrintable: boolean;
  OrderItemId: string;
}

export class CopyAttributeToOtherOrderItemsCommand extends BaseCommand {
  CommandName = "CopyAttributeToOtherOrderItems";
  Command: CopyAttributeToOtherOrderItemsCommandParams;
  constructor(sessionId: string, operationId: string, params: CopyAttributeToOtherOrderItemsCommandParams) {
    super(sessionId, operationId);
    this.Command = params;
  }
}
